import { render, staticRenderFns } from "./ShowDataModal.vue?vue&type=template&id=70c81f82&scoped=true&"
import script from "./ShowDataModal.vue?vue&type=script&lang=js&"
export * from "./ShowDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c81f82",
  null
  
)

export default component.exports